/**
 * Language Configuration
 * Defines supported languages and their metadata
 */

export const LANGUAGES = {
  EN: 'en',
  RU: 'ru',
  FR: 'fr',
  ES: 'es',
  UK: 'uk',
  DE: 'de',
};

export const LANGUAGE_NAMES = {
  en: 'English',
  ru: 'Русский',
  fr: 'Français',
  es: 'Español',
  uk: 'Українська',
  de: 'Deutsch',
};

export const DEFAULT_LANGUAGE = LANGUAGES.EN;

export const SUPPORTED_LANGUAGES = Object.values(LANGUAGES);
